export class PostClosingOptionListApi {
  #http;

  #routeBase;

  constructor(http, routeBase) {
    this.#http = http;
    this.#routeBase = routeBase;
  }

  async getOptions({ skipDeduplication = false } = {}) {
    return this.#http.get(this.#routeBase, { skipDeduplication });
  }

  async getAdminOptions() {
    return this.#http.get(`${this.#routeBase}/admin`, { skipDeduplication: true });
  }

  async createOption(body) {
    return this.#http.post(this.#routeBase, body);
  }

  async editOption({ id, ...body }) {
    return this.#http.put(`${this.#routeBase}/${id}`, body);
  }

  async deleteOption({ id }) {
    return this.#http.delete(`${this.#routeBase}/${id}`);
  }
}
